'use client';

import { JSX } from 'react';

import { Toast } from '@videoblocks/design-system';
import { LoadingRing } from '@videoblocks/design-system/icons';

import { ACTIVE_TASK_TOAST_CONFIG } from '../../_context/activeTaskToastConfig';
import { ActiveTask } from '../../_context/types';

interface AiToolkitToastProps {
    open: boolean;
    onOpenChange?: (open: boolean) => void;
    activeTask: ActiveTask;
}

export const AiToolkitToast = ({ open, onOpenChange, activeTask }: AiToolkitToastProps): JSX.Element | null => {
    const toastConfig = activeTask ? ACTIVE_TASK_TOAST_CONFIG[activeTask.category] : null;

    if (!toastConfig) return null;
    const icon =
        activeTask?.status === 'inProgress' ? (
            <LoadingRing className="size-6 animate-spin [&_path]:stroke-black" />
        ) : null;

    return (
        <Toast
            open={open}
            onOpenChange={onOpenChange}
            variant={
                activeTask?.status === 'inProgress' ? 'neutral' : activeTask?.status === 'success' ? 'success' : 'error'
            }
            title={
                activeTask?.status === 'inProgress'
                    ? toastConfig.inProgressTitle
                    : activeTask?.status === 'success'
                      ? toastConfig.successTitle
                      : toastConfig.errorTitle
            }
            hasClose={false}
            icon={icon}
            viewportClassName="fixed bottom-4 left-4 right-4 md:left-auto md:w-full max-w-161 z-[1050]"
        />
    );
};
